import { connect } from 'react-redux';
import _get from 'lodash-es/get';
import { openErrorToast } from '../../../../reducers/uiLogic/index';
import CreatePolicy from './CreatePolicy';
import {
  getProgramInfoInitiate,
  updateOptionStatusInitiate,
  updateOptionInitiate,
} from '../../../../actions/programs';

const mapStateToProps = state => {
  const programInfo = _get(state, 'programs.programInfo', {});
  const selectedWorkspace = _get(state, 'user.selectedWorkspace', {});
  const companyId = _get(state, 'user.selectedWorkspace.company_id', '');

  return {
    companyId,
    selectedWorkspace,
    programInfo,
    fetchingProgramInfo:
      _get(state, 'apiState.GET_PROGRAM_INFO.isFetching', true) &&
      !_get(state, 'apiState.GET_PROGRAM_INFO.isIdle', false),
    fetchedProgramInfo: _get(state, 'apiState.GET_PROGRAM_INFO.success', true),
    addingOption:
      _get(state, 'apiState.ADD_OPTION.isFetching', false) &&
      !_get(state, 'apiState.ADD_OPTION.isIdle', true),
    addedOption: _get(state, 'apiState.ADD_OPTION.success', true),
    updatingOption:
      _get(state, 'apiState.UPDATE_OPTION.isFetching', false) &&
      !_get(state, 'apiState.UPDATE_OPTION.isIdle', true),
    updatedOption: _get(state, 'apiState.UPDATE_OPTION.success', true),
    updatingOptionStatus:
      _get(state, 'apiState.UPDATE_OPTION_STATUS.isFetching', false) &&
      !_get(state, 'apiState.UPDATE_OPTION_STATUS.isIdle', true),
    updatedOptionStatus: _get(
      state,
      'apiState.UPDATE_OPTION_STATUS.success',
      false,
    ),
  };
};

const mapDispatchToProps = dispatch => ({
  showErrorToast: message => dispatch(openErrorToast(message)),
  getProgramInfo: payload => dispatch(getProgramInfoInitiate(payload)),
  updateOptionStatus: payload => dispatch(updateOptionStatusInitiate(payload)),
  updateOption: payload => dispatch(updateOptionInitiate(payload)),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(CreatePolicy);
